'use strict';

angular.module('TurneroApp').component('coTurnohistorico', {
    bindings: {
        idTurno: '<'
    },
    controller: [
        'turnosService',
        'utilsService',
		  '$mdDialog',
		  '$scope',
        function (
        turnosService,
        utilsService,
		  $mdDialog,
		  $scope
        ) {
            var ctrl = this;

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };
            ctrl.limitOptions = [10, 25, 50, 75, 100, {
            	label: 'Todos',
            	value: function () {
            		return ctrl.pagination.total;
            	}
            }];
        	//Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
            	total: null
            };


            ctrl.$onChanges = function () {
                if (ctrl.idTurno) {
                	ctrl.query.id_turno = ctrl.idTurno;
                    ctrl.grillaReload();
                }

            };

            ctrl.grillaReload = function () {
            	// utilsService.swalTitle('Cargando informacion', 'info')
            	ctrl.showLoading = true;
            	var filtro = {
            		Id_Turno: ctrl.query.id_turno,
            		Nro_Pagina: ctrl.query.page,
						Tam_Pagina: ctrl.query.limit

            	}
            	turnosService.Get_Historial_Turnos({
            		'filtro.Id_Turno': ctrl.query.id_turno,
            		'filtro.Nro_Pagina': ctrl.query.page,
            		'filtro.Tam_Pagina': ctrl.query.limit
            	}).$promise.then(function (data) {
            		ctrl.HistorialTurnos = data.Data;
            		ctrl.pagination.total = data.Pagination.Reg_Totales;
                    ctrl.showLoading = false;
                }).catch(function (error) {
                	ctrl.showLoading = false;
                    if (ctrl.query.id_turno != "")
                        utilsService.errores(error);
                });

            }

            ctrl.openComments = function (Id_Turo) {
            	$mdDialog.show({
            		template: '<co-turnocomentarios id-turno="' + Id_Turo + '" on-modal="true" ></co-turnocomentarios>',
            		parent: angular.element(document.body),
            		clickOutsideToClose: true,
            		fullscreen: false, // Only for -xs, -sm breakpoints.,
            		//parent: $rootElement,
            		scope: $scope,
            		preserveScope: true
            	});

            }
        }
    ],
    template: require('./turnos_historico.html')
});



// WEBPACK FOOTER //
// ./app/components/atencion/turnosHistoricoComponent.js